import http from "./http";

/**
 * Compromissos do médico — salvia-772.
 *
 * Bloqueio RELÂMPAGO da agenda: reunião, imprevisto, compromisso pessoal. Não é
 * recorrente e não tem motivo catalogado — isso é a parametrização de agenda
 * (`/doctor-schedule/blocks`), outra coisa.
 *
 * No banco o compromisso é um evento sem paciente, então ele já entra sozinho no
 * calendário, no recorte da disponibilidade e na recusa de agendar por cima.
 */

/** Cria um compromisso. `payload`: { title, date, start_time, end_time, clinic_id?, description?, time_zone? }. */
export async function createCommitment(payload) {
  const { data } = await http.post("/api/commitments", payload);
  return data?.data || null;
}

/** Compromissos do médico logado no intervalo (YYYY-MM-DD). */
export async function listCommitments({ startDate, endDate }) {
  const { data } = await http.get("/api/commitments", {
    params: { start_date: startDate, end_date: endDate },
  });
  return data?.data || [];
}

export async function updateCommitment(id, payload) {
  const { data } = await http.put(`/api/commitments/${id}`, payload);
  return data?.data || null;
}

export async function deleteCommitment(id) {
  await http.delete(`/api/commitments/${id}`);
}
